import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    description,
    macAddress,
    location,
    timezone,
    project,
    status,
    deviceMacAddress,
    // profileImage,
    // collectIP,
    // signShift,
  },
} = checkout;

export default Yup.object().shape({
  [description.name]: Yup.string().required(description.errorMsg),
  [macAddress.name]: Yup.string().required(macAddress.errorMsg),
  [deviceMacAddress.name]: Yup.string().required(deviceMacAddress.errorMsg),
  [location.name]: Yup.string().required(location.errorMsg),
  [timezone.name]: Yup.string().required(timezone.errorMsg),
  [project.name]: Yup.string(), // .required(project.errorMsg),
  [status.name]: Yup.bool(),
  // [profileImage.name]: Yup.bool(),
  // [collectIP.name]: Yup.bool(),
  // [signShift.name]: Yup.bool(),
});
